import Button from '@components/button';

type ContactProps = {
  name: string;
  phone: string;
  email: string;
  theme?: string;
  className?: string;
};

const AddToContactsButton = ({ name, phone, email, theme, className }: ContactProps) => {
  const handleDownload = () => {
    const vCard = `
BEGIN:VCARD
VERSION:3.0
FN:${name}
TEL;TYPE=CELL:${phone}
EMAIL:${email}
END:VCARD
    `.trim();

    const encoded = encodeURIComponent(vCard);
    const dataUri = `data:text/vcard;charset=utf-8,${encoded}`;

    const link = document.createElement('a');
    link.href = dataUri;
    link.download = `${name.replace(/\s+/g, '_')}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button onClick={handleDownload} label="Add to Contacts" theme={theme} className={className} />
  );
};

export default AddToContactsButton;
